import { createAction } from 'redux-act'

import { CybersourceState } from '../types'

export const initCybersourceCheckout = createAction<CybersourceState>('Cybersource / init checkout')
export const updateCybersourceCheckout = createAction<CybersourceState>(
  'Cybersource / update checkout',
)
export const completeCybersourceCheckout = createAction('Cybersource / complete checkout')

export const apiInitCybersourceStart = createAction('Cybersource / API init start')
export const apiInitCybersourceSuccess = createAction<object>('Cybersource / API init success')
export const apiInitCybersourceFail = createAction('Cybersource / API init fail')
